/**
 * 0〜array_length-1までの配列作成。
 * @param array_length 
 * @returns 
 */
export function makeAryByLength(array_length: number) : number[]
{
  return [...Array(array_length).keys()];
}

/**
 * start_value〜end_valueまでの配列作成。
 * @param start_value 開始値
 * @param end_value 終了値
 * @returns 
 */
export function makeAryByStartEnd(start_value: number, end_value: number) : number[] | undefined
{
  if( start_value <= end_value ){
    return [...Array(end_value - start_value + 1).keys()].map( v => start_value + v);
  }else if( start_value > end_value ){
    return [...Array(start_value - end_value + 1).keys()].map( v => start_value - v);
  }
}
